import { differenceInMinutes } from "date-fns";

/** Refresh when the ID token expires within this window (app-level cache). */
export const TOKEN_REFRESH_BUFFER_MINUTES = 52;

export const getTokenExpirationMs = (tokenResult) => {
  if (tokenResult?.expirationTime) {
    return new Date(tokenResult.expirationTime).getTime();
  }
  if (tokenResult?.claims?.exp) {
    return tokenResult.claims.exp * 1000;
  }
  return null;
};

export const isTokenFreshBeyondBuffer = (
  tokenExpirationTimeMs,
  bufferMinutes = TOKEN_REFRESH_BUFFER_MINUTES
) => {
  if (!tokenExpirationTimeMs) {
    return false;
  }
  const minutesUntilExpiration = differenceInMinutes(
    new Date(tokenExpirationTimeMs),
    new Date()
  );
  return minutesUntilExpiration > bufferMinutes;
};

export const buildAuthUserPayload = (user, tokenResult) => ({
  uid: user.uid,
  email: user.email,
  name: tokenResult.claims.name || user.displayName,
  role: tokenResult.claims?.role,
  country: tokenResult.claims?.country,
  advertiserID: tokenResult.claims?.advertiserID,
  advertisersAvailable: tokenResult.claims?.advertisersAvailable || [],
  agenciesAvailable: tokenResult.claims?.agenciesAvailable || [],
  themeID: tokenResult.claims?.themeID,
  shopID: tokenResult.claims?.shopID,
  agencyID: tokenResult.claims?.agencyID,
  isAnonymous: tokenResult.claims?.isAnonymous,
  token: tokenResult.token,
  tokenExpirationTime: getTokenExpirationMs(tokenResult),
});
